import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gybc_lang") || "en");
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchContent = useCallback(async (l) => {
    try {
      const { data } = await api.get(`/content?lang=${l}`);
      setContent(data.content);
    } catch (e) {
      setContent({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchContent(lang);
  }, [lang, fetchContent]);

  const toggleLang = () => {
    const next = lang === "en" ? "fr" : "en";
    localStorage.setItem("gybc_lang", next);
    setLang(next);
  };

  // translation helper for static UI strings
  const t = (en, fr) => (lang === "fr" ? fr : en);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, content: content || {}, loading, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
